<template>
  <div class="home">
    <My-new-nav ref="header" menuTheme="dark" :mobileShowLogo="false" :isHome="true"></My-new-nav>
    <div class="home-part1">
      <div class="mobile-margin">
        <img class="home_img1" src="../../assets/image/home/moble_home1.png" alt="">
        <img class="home_img2" src="../../assets/image/home/moble_home2.png" alt="">
        <div class="home_text1">让每个人拥有属于自己的医疗专【家】</div>
        <div class="home_text1">让医疗触手可及</div>
      </div>
    </div>
    <div class="home-part2">
      <div class="mobile-margin">
        <div class="home_text3 home_title">医智诺平台生态圈</div>
        <div class="home_text_desc-top home_desc">以人为本提升健康服务，跨界融合助力医疗创新</div>
        <div class="rectangle"></div>
        <div style="text-align: center">
          <img class="home_img3" src="../../assets/image/home/moble_home3.png" alt="">
        </div>
      </div>
    </div>
    <Information class="home-part3"/>
    <div class="home-part4">
      <div class="mobile-margin">
        <div class="home_text3 home_title">部分合作伙伴</div>
        <div class="home_text_desc-top home_desc">携手合作伙伴，共建医疗新生态，共赢未来</div>
        <div class="rectangle"></div>
        <ul>
          <li class="drug" v-for="(item, i) in enterpriseList" :key="i">
            <img :src="item.imgUrl" alt="" />
          </li>
          <li v-if="hasMoreCoop" class="drug" @click.stop="$router.push('/partner_mobile')">
            <img src="../../assets/image/Mobile/more.png" alt=""/>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>

import Information from "@/views/mobile/Information.vue";
import { selectEnterpriseList } from "../../../common/api";
export default {
  components: {Information},
  data() {
    return {
      hasMoreCoop: false,
      enterpriseList: [],
    };
  },
  mounted() {
    this.getCoopEnterpriseList();
  },
  methods: {
    getCoopEnterpriseList() {
      let data = {
        isOfficial: 1,
        pageIndex: 1,
        pageSize: 10000,
      };
      selectEnterpriseList(data).then((res) => {
        if (res.responseCode == 0 && Array.isArray(res.responseBody)) {
          if (res.responseBody.length >= 8) {
            this.enterpriseList = res.responseBody.slice(0, 8)
            this.hasMoreCoop = true;
          } else {
            this.enterpriseList = res.responseBody
          }
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>

.home {
  background-color: #000000;
  width: 100%;
}

.rectangle {
  width: 86px;
  height: 18px;
  background: #0D6EFD;
  opacity: 0.9;
  margin-top: 20px;
}

.home-part1 {
  background-image: url("../../assets/image/home/moble_home_bg.png");
  background-repeat: no-repeat;
  height: 100vh;
  background-size: cover;
}

.home-part2 {
  color: #FFFFFF;
  background-color: #000000;
  opacity: 1;
  background-size: cover;
  width: 100%;
}

.mobile-margin {
  margin: 0 36px;
}

.home-part1 .mobile-margin {
  padding-top: 30%;
}

.home_img1 {
  padding-top: 400px;
  width: 280.5px;
  height: 84px;
  display: block;
}

.home_img2 {
  margin-top: 29px;
  height: 200px;
  margin-left: -18px;
}

.home_img3 {
  margin-top: 130px;
  width: 100%;
}

.home_text1 {
  font-size: 39px;
  color: #FFFFFF;
  line-height: 66px;
  letter-spacing: 12px;
  margin-top: 10px;
}

.home_title {
  font-size: 54px;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 54px;
  letter-spacing: 5px;
}

.home_desc {
  font-size: 30px;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 24px;
  letter-spacing: 5px;
  margin-top: 12px;
}

.home_text3 {
  padding-top: 80px;
}

.home_text_desc-top {
  padding-top: 18px;
}

.home_text5 {
  padding-top: 160px;
}

.home-part4 {
  background-position:  0 790px;;
  background-image: url("../../assets/image/home/drug_bottom.png");
  background-repeat: no-repeat;
  background-size: contain;
  padding-bottom: 130px;
}

.home-part4 ul {
  margin-top: 69px;
  display: flex;
  flex-flow: wrap;
  justify-content: flex-start;
}
.home-part4 ul li {
  background: #fff;
  width: calc((100% - 36px) / 3);
  height: 158px;
  border-radius: 12px;
}
.home-part4 ul li>img {
  width: 100%;
  height: 100%;
}
.home-part4 .drug {
  margin: 18px 18px 0 0;
}
.home-part4 .drug:nth-child(3n) {
  margin-right: 0;
}
</style>
